<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal2" id="SalesUnclosingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('sale.month_close_release_process') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between mb-3">
            <div class="d-flex align-items-center">
              <span class="font-weight-bold text-nowrap mr-2">{{ translations('sale.month_selection') }}</span>
              <select class="custom-select" v-model="searchByMonth">
                <option selected>-</option>
                <option v-for="(m, i) in closedMonths" :key="i" :value="m">{{ m }}{{ translations('sale.month') }}</option>
              </select>
            </div>
            <div class="d-flex">
              <span class="font-weight-bold">{{ translations('sale.total_amount') }}</span>
              <span class="ml-3">{{ grandTotal.toLocaleString() }}</span>
            </div>
          </div>
          <div class="table-scroll">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input v-model="selectAll" class="form-check-input" type="checkbox" value="1" id="all-check">
                      <label class="form-check-label" for="all-check">{{ translations('sale.choice') }}</label>
                    </div>
                  </th>
                  <th>{{ translations('sale.closing_date') }}</th>
                  <th>{{ translations('sale.customer_name') }}</th>
                  <th>{{ translations('sale.purchase_total') }}</th>
                  <th>{{ translations('sale.billed_amount_this_time') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
                <template v-if="closedList.length > 0">
                  <template v-for="(item, i) in closedList">
                    <tr :key="i">
                      <td>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" v-model="selectedItems" :value="item" :id="'check-'+item.id">
                          <label class="form-check-label" :for="'check-'+item.id"></label>
                        </div>
                      </td>
                      <td>{{ $invoiceTools.formatDate(item.closing_at.substr(0,10)) }}</td>
                      <td>{{ item.client_name }}</td>
                      <td class="right">{{ (Number(item.total_amount_inctax)).toLocaleString() }}</td>
                      <td class="right">{{ (Number(item.total_amount)).toLocaleString() }}</td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="7" class="text-center">{{ translations('sale.no_results_found') }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="submitRequest()">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
export default {
  name: 'MonthTighteningReleaseProcess',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      closedList: [],
      grandTotal: 0,
      searchByMonth: '',
      isSearching: false,
      selectedItems: [],
      selectAll: '',
      closedMonths: [],
      isLoading: false
    }
  },
  watch: {
    searchByMonth (newVal) {
      if (newVal) {
        this.loadClosedList()
      }
    },
    selectAll () {
      this._selectAll()
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  created () {
  },
  mounted () {
    window.$(this.$refs.vuemodal2).on('shown.bs.modal', this.getClosedMonths)
    window.$(this.$refs.vuemodal2).on('hidden.bs.modal', this.resetData)
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    resetData () {
      this.searchByMonth = ''
      this.selectAll = 0
      this.closedList = []
      this.grandTotal = 0
      this.selectedItems = []
      this.closedMonths = []
    },
    async getClosedMonths () {
      this.isLoading = true
      try {
        let months = await this.$http.post(this.$api_url.sales_closed_months)
        let $data = this.$invoiceTools.prepareResult(months.data, 'months', 'SalesUnclosingModal:getClosedMonths')
        if ($data.success === true) {
          $data.data.forEach(closeMonth => {
            const year = closeMonth.substring(0, 4)
            const month = closeMonth.substring(5)
            this.closedMonths.push(year + this.translations('sale.year') + month)
          })
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        console.log('SalesUnclosingModal:getClosedMonths:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
        this.isLoading = false
      }
    },
    async loadClosedList () {
      this.isSearching = true
      try {
        const yearMonth = this.searchByMonth.replace(this.translations('sale.year'), '-')
        let closedList = await this.$http.post(this.$api_url.sales_closed_list, { month: yearMonth })
        let $data = this.$invoiceTools.prepareResult(closedList.data, ['list', 'over_all_total'], 'SalesUnclosingModal:loadClosedList')
        if ($data.success === true) {
          this.grandTotal = $data.data.over_all_total
          this.closedList = $data.data.list
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SalesUnclosingModal:loadClosedList:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
      }
      setTimeout(() => {
        this.isSearching = false
      }, 1000)
    },
    _selectAll () {
      if (this.selectAll) {
        this.selectedItems = this.closedList
      } else {
        this.selectedItems = []
      }
    },
    async submitRequest () {
      try {
        let params = []

        this.selectedItems.forEach(item => {
          params.push({
            client_id: item.client_id,
            closing_at: item.closing_at
          })
        })

        if (params.length === 0) {
          this.$toastr.error(this.translations('sale.notice_select'), this.translations('common.error'))
          return
        }

        this.isLoading = true
        let close = await this.$http.post(this.$api_url.sales_open, { list: params })
        let $data = this.$invoiceTools.prepareResult(close.data, '', 'SalesUnclosingModal:submitRequest')
        if ($data.success === true) {
          this.$toastr.success(this.translations('sale.notice_operation_was_successful'), this.translations('common.success'))
          this.$refs.closeModal.click()
          setTimeout(() => {
            this.$emit('unclosed')
          }, 100)
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('SalesUnclosingModal:submitRequest:catch(error): ', error)
        this.$toastr.error(
          this.translations('sale.notice_failed'),
          this.translations('common.error')
        )
      }
    }
  }
}
</script>
